import {
  CompetitionListResponse,
  CompetitionsQueryParams,
  EventsResponse,
} from '@/types/competitionFixture';
import { apiSlice } from './apiSlice';

export const competitionFixtureApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompetitions: builder.query<
      CompetitionListResponse,
      Pick<CompetitionsQueryParams, 'sport' | 'search'> | void
    >({
      query: ({ sport, search } = {}) => {
        const params = new URLSearchParams();

        if (sport) params.append('sport', sport);
        if (search) params.append('search', search);

        const queryString = params.toString();

        return {
          url: `/competitions${queryString ? `?${queryString}` : ''}`,
          method: 'GET',
        };
      },
    }),

    getCompetitionEvents: builder.query<
      EventsResponse,
      Pick<
        CompetitionsQueryParams,
        'page' | 'limit' | 'sport' | 'status' | 'competitionId' | 'search' | 'inplay' | 'matchTime'
      > | void
    >({
      query: ({ page, limit, sport, status, competitionId, search, inplay, matchTime } = {}) => {
        const params = new URLSearchParams();

        if (page) params.append('page', String(page));
        if (limit) params.append('limit', String(limit));
        if (sport) params.append('sport', sport);
        if (status) params.append('status', status);
        if (competitionId) params.append('competitionId', String(competitionId));
        if (search) params.append('search', search);
        if (inplay) params.append('inplay', inplay);
        if (matchTime) params.append('matchTime', matchTime);

        const queryString = params.toString();

        return {
          url: `/events${queryString ? `?${queryString}` : ''}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useGetCompetitionsQuery, useGetCompetitionEventsQuery } = competitionFixtureApi;
